module.exports = __webpack_public_path__ + "img/trustwallet1.292fc4b6.png";